// extracted by mini-css-extract-plugin
export default {"steps":"Process_steps__jIP8u","step":"Process_step__F6nDy","num":"Process_num__zj9wq"};